"use strict";
exports.__esModule = true;
exports.Button = void 0;
var Button_1 = require("./Button");
var ButtonLabel_1 = require("./ButtonLabel");
var Button = Object.assign(Button_1.Button, { Label: ButtonLabel_1.ButtonLabel });
exports.Button = Button;
//# sourceMappingURL=index.js.map